import { render, staticRenderFns } from "./UserRetail.vue?vue&type=template&id=abf008e6"
import script from "./UserRetail.vue?vue&type=script&lang=js"
export * from "./UserRetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports